<template>
  <q-toggle
    :value="isBlocked"
    @input="toggleBlock"
    :label="label"
    :disable="loading"
  />
</template>

<script>
import { QToggle } from 'quasar';
import { api } from 'mixins/api';

export default {
  name: "ProjectSsl",

  components: {
    QToggle,
  },

  props: {
    project: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    isBlocked() {
      return this.project.is_blocked || false;
    },
    
    label() {
      if (this.loading) {
        return this.isBlocked ? 'Домены разблокируются...' : 'Домены блокируются...';
      }
      return this.isBlocked ? 'Домены заблокированы' : 'Домены разблокированы';
    },
  },

  methods: {
    toggleBlock(shouldBlock) {
      if (shouldBlock) {
        this.$q.dialog({
          title: 'Блокировка доменов проекта',
          message: 'Вы действительно хотите заблокировать домены этого проекта?\nПосле этого действия домены проекта перестанут работать.',
          color: 'negative',
          ok: {
              label: 'Заблокировать домены',
              color: 'negative',
              push: true
          },
          cancel: {
              label: 'Отмена',
              color: 'grey-7',
              flat: true
          },
          className: 'project-ssl-dialog'
        }).then(() => this.blockProject()).catch(() => {});
      } else {
        this.$q.dialog({
          title: 'Разблокировка доменов проекта',
          message: 'Вы действительно хотите разблокировать домены этого проекта?\nПосле этого действия домены проекта снова заработают.',
          color: 'primary',
          ok: {
              label: 'Разблокировать домены',
              color: 'primary',
              push: true
          },
          cancel: {
              label: 'Отмена',
              color: 'grey-7',
              flat: true
          },
          className: 'project-ssl-dialog'
        }).then(() => this.unblockProject()).catch(() => {});
      }
    },

    blockProject() {
      this.loading = true;
      
      api.post(`projects/${this.project.id}/block`)
        .then((response) => {
          this.$store.commit('project/setProjectBlocked', response.data.blocked);
        })
        .catch(this.handleError)
        .finally(() => {
          this.loading = false;
        });
    },

    unblockProject() {
      this.loading = true;
      
      api.post(`projects/${this.project.id}/unblock`)
        .then((response) => {
          this.$store.commit('project/setProjectBlocked', response.data.blocked);
        })
        .catch(this.handleError)
        .finally(() => {
          this.loading = false;
        });
    },
    
    handleError(error) {
      this.$q.dialog({
        title: 'Ошибка',
        message: error?.response?.data?.message || 'Не удалось изменить статус проекта',
        ok: true,
      });
    }
  }
}
</script>

<style>
.project-ssl-dialog .modal-message {
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ProjectSsl/ProjectSsl.vue